module.exports = __webpack_public_path__ + "img/twitter.357e9d25.svg";